import React from "react";
import _ from "underscore";
import DatePicker from "react-datepicker";
import { setHours, setMinutes, setSeconds } from "date-fns";
import { Dash } from "../styled_components/exporter";
import { minStart, maxStart, minEnd } from "../utility/minMaxTime";
import useWeeklyDropdown from "../hooks/useWeeklyDropdown";
import { HoursWeek } from "../styled_components/styled_weekdays/index";
import { DeleteHours } from "../styled_components/exporter";
import t from "../../../helpers/t";
import TimeSelect from "../../../components/TimeSelect";

const uuid = _.uniqueId;

const WeeklyDropdown = ({ handleAddTime, hourly, reference, anytime }) => {
  const { startDate, handleStartDate, endDate, handleEndDate, handleDeleteHours } =
    useWeeklyDropdown({ hourly, handleAddTime, reference });

  const testArray = (hour) =>
    hour.end &&
    hour.end.split(":").slice(0, 2).join(":") === "23:59" &&
    hour.begin &&
    hour.begin.split(":").slice(0, 2).join(":") === "00:00";

  let showIt = false; //testArray(hourly);
  console.log("startDate", startDate);
  let uid = uuid();
  return (
    <HoursWeek key={uid}>
      <TimeSelect
        minTime={minStart(reference)}
        maxTime={maxStart(endDate)}
        step={15}
        changeHandler={handleStartDate}
        extraClasses={"width_75"}
        value={startDate}
        uid={uid}
      />
      {/*<DatePicker
        selected={!showIt && startDate ? startDate : ""}
        onChange={date => handleStartDate(date)}
        onKeyDown={e => e.preventDefault()}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={15}
        timeFormat="HH:mm"
        minTime={minStart(reference)}
        maxTime={maxStart(endDate)}
        dateFormat="HH:mm"
      />*/}
      <div key={uuid()} className="react-datepicker-wrapper">
        <div className="react-datepicker__input-container">
          <Dash>&mdash;</Dash>
        </div>
      </div>
      {/*<DatePicker
        selected={!showIt && endDate ? endDate : ""}
        onChange={date => handleEndDate(date)}
        onKeyDown={e => e.preventDefault()}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={15}
        timeFormat="HH:mm"
        minTime={minEnd(reference, startDate)}
        maxTime={setHours(setMinutes(setSeconds(new Date(), 59),59), 23)}
        dateFormat="HH:mm"
      />*/}
      <TimeSelect
        minTime={minEnd(reference, startDate)}
        maxTime={setHours(setMinutes(setSeconds(new Date(), 59), 59), 23)}
        step={15}
        changeHandler={handleEndDate}
        extraClasses={"width_75"}
        value={endDate}
        uid={uid}
      />
      <DeleteHours
        toShow={startDate && !anytime}
        onClick={() => {
          if (window.confirm(t("really_remove"))) {
            handleDeleteHours(hourly.id, hourly.check_in_period_id);
          }
        }}
      >
        x
      </DeleteHours>
    </HoursWeek>
  );
};

export default WeeklyDropdown;
